import { useCallback, useRef } from 'react';
import { useExpose } from '@/app/hooks';
import { reportEvent } from '@/app/utils';
import { usePathname } from '@/i18n/routing';
import type { Medal } from './types';
import { getPageNameForReport } from './utils';

export const useMedalTracking = (medals: Medal[] = []) => {
  const pathname = usePathname();
  const medalElementsRef = useRef<HTMLDivElement[]>([]);
  const medalsRef = useRef<Medal[]>([]);
  // 保存最新的 medals 引用
  medalsRef.current = medals;

  const handleMedalExpose = useCallback(
    (index: number) => {
      const medal = medalsRef.current[index];
      if (!medal?.user_medal_type) return;

      reportEvent('budget_show', {
        budget_type: medal.user_medal_type,
        page_name: getPageNameForReport(pathname),
      });
    },
    [pathname],
  );

  useExpose(handleMedalExpose, medalElementsRef.current, medals, 0.5);

  const reportMedalClick = useCallback(
    (medal: Medal, button: string) => {
      if (!medal.user_medal_type) return;

      reportEvent('budget_click', {
        budget_type: medal.user_medal_type,
        page_name: getPageNameForReport(pathname),
        budget_button: button,
      });
    },
    [pathname],
  );

  const setMedalElementRef = useCallback((element: HTMLDivElement | null, index: number) => {
    if (element) {
      medalElementsRef.current[index] = element;
    } else {
      // 清理已移除的元素引用
      delete medalElementsRef.current[index];
    }
  }, []);

  return {
    reportMedalClick,
    setMedalElementRef,
  };
};
